import React, { CSSProperties } from "react";

type ButtonProps = {
  value?: string;
  btnType?: "green" | "red" | "blue";
  onClick?: any;
  style?: CSSProperties;
  disabled?: boolean;
};

const map = {
  green: "green-btn",
  red: "red-btn",
  blue: "blue-btn",
};

const Button: React.FC<ButtonProps> = ({
  style,
  onClick,
  value,
  disabled,
  btnType: type = "green",
}) => {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid

    <button
      disabled={disabled}
      onClick={onClick}
      style={style}
      type="submit"
      className={`btn-americau ${map[type]}`}
    >
      <a>{value}</a>
    </button>
  );
};

export default Button;
